import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  clearSession,
  deleteListing,
  getMyListings,
  getToken,
  getUserProfile,
} from "./api";

export function ProfilePage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [listings, setListings] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!getToken()) {
      navigate("/giris?next=/profil", { replace: true });
      return;
    }
    Promise.all([getUserProfile(), getMyListings()])
      .then(([account, items]) => {
        setUser(account);
        setListings(items || []);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [navigate]);
  const removeListing = async (listing) => {
    if (
      !window.confirm(
        `“${listing.baslik || "Bu ilan"}” ve bağlı görseller kalıcı olarak silinecek. Devam edilsin mi?`,
      )
    )
      return;
    setError("");
    try {
      await deleteListing(listing.ilan_no);
      setListings((items) =>
        items.filter((item) => item.ilan_no !== listing.ilan_no),
      );
    } catch (reason) {
      setError(reason.message);
    }
  };
  // The API returns only this account's listings and checks ownership for every
  // update/delete request, so role metadata from legacy accounts must not hide
  // their own management controls.
  const canManageListings = Boolean(user);
  if (loading)
    return (
      <main className="shell section">
        <p>Profil yükleniyor…</p>
      </main>
    );
  if (error)
    return (
      <main className="shell section">
        <div className="error">{error}</div>
      </main>
    );
  return (
    <main className="shell section profile-page">
      <div className="profile-head">
        <div>
          <p className="eyebrow">HESABIM</p>
          <h1>{user?.ad_soyad || user?.kullanici_adi}</h1>
          <p>{user?.email}</p>
        </div>
        <button
          className="logout"
          onClick={() => {
            clearSession();
            navigate("/");
          }}
        >
          Çıkış yap
        </button>
      </div>
      <section className="profile-summary">
        <div>
          <strong>{listings.length}</strong>
          <span>İlanım</span>
        </div>
        <Link to="/mesajlar">
          <strong>✉</strong>
          <span>Mesajlarım</span>
        </Link>
        <Link to="/profil-duzenle">
          <strong>✎</strong>
          <span>Profili düzenle</span>
        </Link>
      </section>
      <section className="profile-panel">
        <div className="panel-title">
          <h2>İlanlarım</h2>
          {canManageListings && (
            <Link className="button" to="/ilan-ver">
              Yeni ilan ver
            </Link>
          )}
        </div>
        {listings.length ? (
          <div className="my-listings">
            {listings.map((listing) => (
              <article key={listing.ilan_no}>
                <div>
                  <h3>{listing.baslik || "Başlıksız ilan"}</h3>
                  <p>{listing.adres || "Adres bilgisi yok"}</p>
                </div>
                <div>
                  <strong>{listing.fiyat || "Fiyat yok"}</strong>
                  <Link to={`/ilan/${listing.ilan_no}`}>Görüntüle</Link>
                  {canManageListings && (
                    <>
                      <Link to={`/ilan-duzenle/${listing.ilan_no}`}>
                        Düzenle
                      </Link>
                      <button
                        type="button"
                        className="listing-delete"
                        onClick={() => removeListing(listing)}
                      >
                        Sil
                      </button>
                    </>
                  )}
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="empty">Henüz ilanınız bulunmuyor.</div>
        )}
      </section>
    </main>
  );
}
